// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyCqRfrMz_4PO7C5WelEnJhQQyATknaLcts",
    authDomain: "testfirebase-1f7fe.firebaseapp.com",
    projectId: "testfirebase-1f7fe",
    storageBucket: "testfirebase-1f7fe.appspot.com",
    messagingSenderId: "559514947215",
    appId: "1:559514947215:web:167db919b4297c4225aafa",
    measurementId: "G-LGL52HCXRQ"
  }
};

/*
var firebaseConfig = {
    apiKey: "AIzaSyBvapnXjb9x_QbYWNQIECxF9xtR9QL3gko",
    authDomain: "inmobiliaria-pablo-arenas.firebaseapp.com",
    databaseURL: "https://inmobiliaria-pablo-arenas.firebaseio.com",
    projectId: "inmobiliaria-pablo-arenas",
    storageBucket: "inmobiliaria-pablo-arenas.appspot.com",
    messagingSenderId: "93538514780",
    appId: "1:93538514780:web:a76b30ea350b669f78f399"
  };
*/

//export const api = "https://localhost:44381/";
export const api = "https://pabloarenas.uy/api/";

export const apiPanel = "https://cotizacionexperiencetravel.com.uy/administracion/API/"